<template>
  <div>
    <div v-if="!isLoading" class="table-responsive mb-4">
      <table
        v-if="Array.isArray(workOrders) && workOrders.length > 0"
        class="table border table-entitlement"
        style="table-layout:fixed"
      >
        <thead class="thead-light">
          <tr>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.firstCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.secondCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.thirdCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.fourthCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text" 
              v-html="tableHeaders.fithCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.sixthCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w20 small-text"
              v-html="tableHeaders.seventhCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.eigthCol"
            ></th>
            <th
              scope="col"
              class="p-1 pl-4 text-uppercase font-weight-bold paragraph-reduced w10 small-text"
              v-html="tableHeaders.ninthCol"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(workOrder, i) in workOrders" :key="i">
            <td class="p-1 pl-4 small-text">{{ workOrder.CRN }}</td>
            <td class="p-1 pl-4 small-text">
              {{ workOrder.displayName || workOrder.woWasteType }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ formatDate(workOrder.woCreatedDateTime) }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ formatDate(workOrder.woScheduledDateTime) }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ formatDate(workOrder.woCompletedDateTime) }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ getBulkUsedUp(workOrder) }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ workOrder.woStatusReasonDesc }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ workOrder.Comments }}
            </td>
            <td class="p-1 pl-4 small-text">
              {{ workOrder.phonenumber }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="addressId" class="m-4 text-center">
        No records found
      </div>
    </div>
    <div v-else class="m-4 text-center">
      <LoaderCircle size="small" />
    </div>
  </div>
</template>

<script>
import Texts from "../utils/Texts";
import DateNoTz from "../utils/DateNoTz";
import LoaderCircle from "../components/LoaderCircle";
import WorkOrderHistoryMixin from "../mixins/WorkOrderHistoryMixin";
export default {
  mixins: [WorkOrderHistoryMixin],
  components: {
    LoaderCircle,
  },
  props: {
    addressId: String,
  },
  data() {
    return {
      workOrders: [],
      addressEntitlementHash: {},
      isLoading: false,
      nameHash: null,
    };
  },
  computed: {
    tableHeaders() {
      return {
        firstCol: Texts.render(`ADDRESS_DETAILS_TABLE_FIRST_COL`),
        secondCol: Texts.render(`ADDRESS_DETAILS_TABLE_SECOND_COL`),
        thirdCol: Texts.render(`ADDRESS_DETAILS_TABLE_THIRD_COL`),
        fourthCol: Texts.render(`ADDRESS_DETAILS_TABLE_FOURTH_COL`),
        fithCol: Texts.render(`ADDRESS_DETAILS_TABLE_FIFTH_COL`),
        sixthCol: Texts.render(`ADDRESS_DETAILS_TABLE_SIXTH_COL`),
        seventhCol: Texts.render(`ADDRESS_DETAILS_TABLE_SEVENTH_COL`),
        eigthCol: Texts.render(`ADDRESS_DETAILS_TABLE_EIGTH_COL`),
        ninthCol: Texts.render(`ADDRESS_DETAILS_TABLE_NINTH_COL`),
      };
    },
  },
  mounted() {},
  watch: {
    addressId(newValue, oldValue) {
      if (!newValue || newValue == oldValue) return;
      else this.getAddressDetails(newValue);
    },
  },
  methods: {
    getAddressDetails(addressId = this.addressId) {
      var self = this;
      self.isLoading = true;
      self.$store
        .dispatch("getAddressEntitlementV3", addressId)
        .then((data) => {
          self.addressEntitlementHash = data;
          if (data && Array.isArray(data.list)) {
            self.addressEntitlementHash = self.buildEntitlementUsageHash(
              data.list
            );
          }
        })
        .then(() => {
          self.$store.dispatch("getWorkOrder", addressId).then((data) => {
            if (data && Array.isArray(data.workOrders)) {
              data.workOrders = data.workOrders.filter(
                (workOrder) => workOrder.woServiceType == "Hardwaste"
              );
              var workOrderNameHash = self.buildWorkOrderNameHash(
                data.workOrders
              );

              data.workOrders.forEach((workOrder) => {
                var nameHash = workOrderNameHash[workOrder.CRN] || [];
                var foundServiceSetting =
                  nameHash.find(
                    (service) =>
                      workOrder.woServiceType.toLowerCase() ==
                      service.serviceApi.toLowerCase()
                  ) || {};
                workOrder.displayName = foundServiceSetting.displayName;
              });

              self.workOrders = data.workOrders;
            }
            self.isLoading = false;
          });
        })
        .catch((err) => {
          console.error("got error when get address detail", err);
          self.isLoading = false;
        });
    },
    formatDate(date) {
      return date ? new DateNoTz(date).formatDdMonYyyy() : date;
    },
    getWasteTypeDisplayName(woName) {
      return woName;
    },
    getBulkUsedUp(workOrder) {
      // --- get entitlements claimed or entitlements credited
      var bulkUsedCount;
      var entitlementDetail = this.addressEntitlementHash[workOrder.CRN] || {};
      if (entitlementDetail.entitlementsClaimed) {
        bulkUsedCount = entitlementDetail.entitlementsClaimed;
      } else if (entitlementDetail.entitlementsCredited) {
        bulkUsedCount = "-" + entitlementDetail.entitlementsCredited;
      }
      return bulkUsedCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.w10 {
  width : 10%
}
.w20 {
  width : 20%
}
.small-text{
  font-size: 0.79rem
}
.spinner {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.spinner--1 {
  border-top: 2px solid #c7c7c7;
  animation: spinner1 600ms linear infinite;
}
@keyframes spinner1 {
  to {
    transform: rotate(360deg);
  }
}
</style>